export default "query getNazioni {\n    getNazioni\n}";